import React, { useEffect, useState } from "react";
import { Alert, Dropdown, Spinner, Table } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";

import AdminDashboard from "../AdminDashboard";
import MainSearch from "../../../Components/Body/MainSearch";
import PagePagination from "../../../Components/Body/PagePagination";
import { basicConfigMultipart } from "../../../constants";
import { Check, ThreeDots } from "react-bootstrap-icons";
import { showNotificationG } from "../../../methods/notificationManager";

const per_page_limit = 10;

const ListCustomers = () => {
  const location = useLocation();

  const urlParams = new URLSearchParams(location.search);

  const search = urlParams.get("q");

  const page = urlParams.get("page") || 1;

  const [customersCount, setCustomersCount] = useState(1);

  const [pages, setPages] = useState(1);

  const [loading, setLoading] = useState(true);

  const [showError, setShowError] = useState(false);

  const [customersList, setCustomersList] = useState([]);

  useEffect(() => {
    const fetchCustomers = async (search, per_page_limit) => {
      setShowError(false);
      setLoading(true);

      let formData = new FormData();

      formData.append("limit", per_page_limit);
      formData.append("page", page);

      if (search && search.trim().length > 0) {
        formData.append("q_search", search);
      }

      await axios
        .post(
          `${process.env.REACT_APP_API_URL}/users/filter/`,
          formData,
          basicConfigMultipart
        )
        .catch((_) => {
          setShowError(true);
        })
        .then((response) => {
          if (response && response.status === 200) {
            setCustomersCount(response.data["count"]);
            setCustomersList(response.data["users"]);
          } else {
            setShowError(true);
          }
        });

      setLoading(false);
    };

    fetchCustomers(search, per_page_limit);
  }, [page, search]);

  useEffect(() => {
    setPages(Math.ceil(customersCount / per_page_limit));
  }, [customersCount]);

  const sendActivationEmail = async (email) => {
    await axios
      .post(`${process.env.REACT_APP_API_URL}/auth/users/resend_activation/`, {
        email: email,
      })
      .catch((_) => {
        // console.log(_);
        showNotificationG("Could not send activation Email.");
      })
      .then((response) => {
        // console.log(response);
        if (response && (response.status === 200 || response.status === 204)) {
          showNotificationG("Activation Email Sent.");
        } else {
          showNotificationG("Could not send activation Email.");
        }
      });
  };

  return (
    <AdminDashboard>
      <>
        {showError && (
          <Alert
            variant="danger"
            onClose={() => {
              setShowError(false);
            }}
            dismissible
          >
            <Alert.Heading>Error fetching.</Alert.Heading>
          </Alert>
        )}
        {loading && <Spinner animation="grow" />}
        <div className="admin_content">
          <div className="admin_content_header">
            <h4>Customers</h4>
          </div>
          {/* place a searchbox here */}
          <MainSearch />

          <div className="admin_content_content">
            <Table striped hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Email</th>
                  <th>Name</th>
                  <th>Phone Number</th>
                  <th>Address</th>
                  <th>Active</th>
                  <th>Staff</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {customersList.map((customer, index) => {
                  return (
                    <tr key={index}>
                      <td>{(page - 1) * 10 + (index + 1)}</td>
                      <td>
                        {/* <Link to={`/admin/customers/${customer.id}`}> */}
                        {customer.email}
                        {/* </Link> */}
                      </td>
                      <td>{customer.name}</td>
                      <td>{customer.phone_number}</td>
                      <td
                        style={{
                          fontSize: "12px",
                          width: "100px",
                          textAlign: "left",
                        }}
                      >
                        {customer.address?.address} {customer.address?.town}{" "}
                        {customer.address?.county} {customer.address?.country}
                      </td>
                      <td>{(customer.is_active ?? false) && <Check />}</td>
                      <td>{(customer.is_staff ?? false) && <Check />}</td>
                      <td>
                        <Dropdown>
                          <Dropdown.Toggle>
                            <ThreeDots />
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {!customer.is_active && (
                              <Dropdown.Item
                                key={index}
                                onClick={() =>
                                  sendActivationEmail(customer.email)
                                }
                              >
                                Send Activation Email
                              </Dropdown.Item>
                            )}
                            {customer.is_active && (
                              <>
                                <Dropdown.Item
                                  key={index}
                                  as={Link}
                                  role=""
                                  to={`/admin/cart/${customer.email}`}
                                >
                                  View Open Cart
                                </Dropdown.Item>
                                <Dropdown.Item
                                  key={index}
                                  as={Link}
                                  role=""
                                  to={`/admin/orders/${customer.email}`}
                                >
                                  View Orders
                                </Dropdown.Item>
                                <Dropdown.Item
                                  key={index}
                                  as={Link}
                                  role=""
                                  to={`/admin/mail/${customer.email}`}
                                >
                                  Send Mail
                                </Dropdown.Item>
                              </>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>

            {/* pagination here */}
            <PagePagination page={parseInt(page) || 1} pages={pages} />
          </div>
        </div>
      </>
    </AdminDashboard>
  );
};

export default ListCustomers;
